export const SITE = {
  name: "Tri County Allstars",
  slogan: "Different Parks. One Coast. One Mission.",
  director: "Coach KP",
  phone: "(772) 306-3012",
  tel: "tel:7723063012",
  email: "kelvinpollock370@icloud.com",
  mailto: "mailto:kelvinpollock370@icloud.com",
  location: "Treasure Coast, Florida",
  field: "PSLAA",
  address: "346 NW Irving Street, Port St. Lucie, FL",
};

export const MAP_EMBED =
  "https://maps.google.com/maps?q=346%20NW%20Irving%20Street%2C%20Port%20St.%20Lucie%2C%20FL&t=&z=15&ie=UTF8&iwloc=&output=embed";
export const directionsUrl = (address) =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address || SITE.address)}`;

export const COMMUNITIES = ["Fort Pierce", "Port St. Lucie", "Vero Beach", "Sebastian", "Stuart", "Okeechobee"];

export const DIVISIONS = [
  { slug: "6u", name: "6U" },
  { slug: "7u", name: "7U" },
  { slug: "8u", name: "8U" },
  { slug: "9u", name: "9U" },
  { slug: "10u", name: "10U" },
  { slug: "11u", name: "11U" },
  { slug: "12u", name: "12U" },
  { slug: "8th-grade", name: "8th Grade" },
];
export const divisionName = (slug) => DIVISIONS.find((d) => d.slug === slug)?.name || slug || "";

export const MEDIA_CATS = [
  "Latest News",
  "Game Highlights",
  "Athlete Interviews",
  "Photo Galleries",
  "Behind the Scenes",
  "Team Announcements",
  "Tournament Coverage",
  "All Things Sports (ATS)",
];

export const CONTACT_CATS = [
  "Parent Questions",
  "Athlete Registration",
  "Coaching Opportunities",
  "Sponsorship",
  "Media",
  "General Information",
];

export const SPONSOR_OPPS = [
  { key: "Team Sponsorships", body: "Put your business behind an entire division as it represents the Treasure Coast." },
  { key: "Athlete Support", body: "Help families cover the cost of postseason opportunities for deserving athletes." },
  { key: "Uniform Sponsorships", body: "Support the jerseys, uniforms and gear our athletes wear on the big stage." },
  { key: "Tournament Travel Assistance", body: "Help teams travel to AUG tournament weekends and national competition." },
  { key: "Event Partnerships", body: "Partner on tryouts, showcases and community events hosted on the Coast." },
  { key: "Equipment Donations", body: "Provide footballs, training equipment and field gear for practices." },
  { key: "Community Partnerships", body: "Join forces with us to invest in the young athletes of our communities." },
];

export const FAQS = [
  { q: "Does my athlete need an invitation?", a: "No. Athletes may register and attend tryouts without receiving an invitation." },
  { q: "Are tryouts fully padded?", a: "Yes. Athletes should arrive with the required football equipment." },
  { q: "Does my athlete need previous football experience?", a: "Yes. Previous football experience is required, although athletes do not necessarily need to be on a current team roster." },
  { q: "What ages are eligible?", a: "Athletes ages 6–13, subject to division eligibility." },
  { q: "How long is the Allstar season?", a: "Our postseason competition includes two tournament weekends." },
  { q: "What are the tournament fees?", a: "The $80 option covers registration and a jersey. The $165 package includes registration, uniform, sweatsuit, travel bag and compression shirt." },
  { q: "When do practices begin?", a: "Practices begin following the conclusion of the selected team's regular season." },
  { q: "Where are practices held?", a: "PSLAA Field, 346 NW Irving Street, Port St. Lucie, FL." },
];

export const TRYOUT = {
  title: "2027 Tri County Allstars Tryouts",
  date: "October 25, 2026",
  checkin: "10:00 AM",
  window: "11:00 AM – 3:00 PM",
  location: "PSLAA Field",
  address: SITE.address,
  ages: "6–13",
  equipment: "Fully padded tryouts",
};

export const BRAND = {
  logo: "/brand/logo.png",
  poster: "/brand/poster.jpg",
  ring: "/brand/a1.jpg",
  gloves: "/brand/a2.jpg",
  jersey: "/brand/a3.jpg",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1537882111161-c3379a777c8b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  lights: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  catch: "https://images.unsplash.com/photo-1640693316735-3fe5ee2de856?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  night: "https://images.pexels.com/photos/18038480/pexels-photo-18038480.jpeg?auto=compress&cs=tinysrgb&w=1600",
  qb: "https://images.pexels.com/photos/159819/american-football-football-football-player-quarterback-159819.jpeg?auto=compress&cs=tinysrgb&w=1600",
  huddle: "https://images.pexels.com/photos/186076/pexels-photo-186076.jpeg?auto=compress&cs=tinysrgb&w=1600",
  stadium: "https://images.unsplash.com/photo-1699858050330-303f07d64afa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  coast: "https://images.unsplash.com/photo-1776028483516-ffaf3c64ad42?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
};
